
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { FontIcon } from "office-ui-fabric-react";
import { Text } from 'office-ui-fabric-react';
import { mergeStyleSets } from '@uifabric/merge-styles';

const classNames = mergeStyleSets({
    icon: {
        marginRight: '1em'
    },

    root1: {
        backgroundColor: '#eeeeee',
        padding: '1em'
    },

    root2: {
        backgroundColor: '#ffffff',
        padding: '1em'
    },

    heading: {
        paddingTop: '1em',
        borderBottom: '1px solid #000000'
    },

    headingElement1: {
        width: '33%',
        display: 'flex',
        justifyContent: 'flex-start',
        borderRight: '1px solid #000000',
        padding: '0em 1em 0em 0em'
    },

    headingElement2: {
        width: '33%',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0em 1em'
    },

    headingElement3: {
        width: '33%',
        display: 'flex',
        justifyContent: 'space-between',
        borderLeft: '1px solid #000000',
        padding: '0em 0em 0em 1em'
    },

    headingContent: {
        marginBottom: '1em'
    },

    sumBox: {
        padding: '1em 0.2em 0.5em 0.2em'
    },
})

const Usek = ({
    quantity,
    col,
    attributes,
    modificationBuilding,
    modificationVegetation,
    onRenderModification,
    operationsBuilding,
    operationsVegetation,
    price,
    usek
}) => {

    const renderModification = (modification, operations) => {
        if (modification && onRenderModification) {
            return onRenderModification(modification, operations);
        }
    }

    let root;
    if (col === 0) {
        root = classNames.root1;
    } else {
        root = classNames.root2;
    }

    return (
        <Stack className={root}>
            <Stack.Item horizontal className={classNames.heading}>
                <Stack horizontal className={classNames.headingContent}>
                    <Stack.Item horizontal className={classNames.headingElement1}>
                        <FontIcon className={classNames.icon} iconName="GripperDotsVertical"></FontIcon>
                        <Text className={classNames.headingText} variant={'mediumB'}>Úsek meze: {usek.properties.id_usek}</Text>
                    </Stack.Item>
                    <Stack.Item horizontal className={classNames.headingElement2}>
                        <Text className={classNames.headingText} variant={'smallB'}>Plocha:</Text>
                        <Text className={classNames.headingText} variant={'medium'}>{quantity['m2']} m²</Text>
                    </Stack.Item>
                    <Stack.Item horizontal className={classNames.headingElement3}>
                        <Text className={classNames.headingText} variant={'smallB'}>Objem:</Text>
                        <Text className={classNames.headingText} variant={'medium'}>{quantity['m3']} m³</Text>
                    </Stack.Item>
                </Stack>
            </Stack.Item>
            <Stack.Item>
                {renderModification(modificationBuilding, operationsBuilding)}
            </Stack.Item>
            <Stack.Item>
                {renderModification(modificationVegetation, operationsVegetation)}
            </Stack.Item>
            <Stack.Item className={classNames.sumBox}>
                <Text variant={'mediumB'}>
                    Celkem cena za úsek: {new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: 'CZK' }).format(price)}
                </Text>
            </Stack.Item>
            <hr/>
        </Stack>
    );
}

export default Usek;
